/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { fg } from '@atlaskit/platform-feature-flags';

import {
	ResizableNativeEmbedCoordinator,
	type ResizableNativeEmbedCoordinatorProps,
} from './ResizableNativeEmbedCoordinator';

export const resizerNextTestId = 'nativeEmbed.resizerNext.testid';

const HIDE_NATIVE_EMBED_RESIZE_CONTROLS_CONFIG = 'platform_native_embeds_hide_resize_controls';

export type ResizableNativeEmbedProps = ResizableNativeEmbedCoordinatorProps;

export const ResizableNativeEmbed = (props: ResizableNativeEmbedProps): JSX.Element | null => {
	const editorViewMode = useSharedPluginStateWithSelector(
		props.pluginInjectionApi,
		['editorViewMode'],
		(states) => states.editorViewModeState?.mode,
	);
	const shouldHideResizeControls = FeatureGates.getExperimentValue<boolean>(
		HIDE_NATIVE_EMBED_RESIZE_CONTROLS_CONFIG,
		'value',
		false,
	);

	if (fg('cc-native-embed-resize-refactor')) {
		return null;
	}

	if (shouldHideResizeControls && (props.disabled || editorViewMode === 'view')) {
		return null;
	}

	// eslint-disable-next-line react/jsx-props-no-spreading -- thin FG-switch wrapper
	return <ResizableNativeEmbedCoordinator {...props} />;
};
